// src/componentes/Auth/RequireAuth.jsx
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const RequireAuth = () => {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const auth = getAuth();

  useEffect(() => {
    const unsubs = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setChecking(false);
    });
    return () => unsubs();
  }, [auth]);

  if (checking) {
    return <div>Cargando estado de sesión…</div>;
  }

  if (!user) {
    // no está autenticado, lo mandamos al login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // sí está autenticado, renderiza las rutas hijas
  return <Outlet />;
};

export default RequireAuth;
